import {isOffHours, normalizeWorkTime} from './work-time';
import formatPrice from './format-price';

export const getLocationServicePrice = (service, options = {}) => {
    const {
        isPickup = false,
        startHours = null,
        finishHours = null,
        workTime = null,
    } = options;

    if (!service) {
        return 0;
    }

    let price = parseInt(service.caraddonprice || 0, 10);
    const surcharge = parseInt(service.off_hours_surcharge || 0, 10);

    if (surcharge > 0) {
        const normalizedWorkTime = normalizeWorkTime(workTime);

        if (isPickup && isOffHours(startHours, 0, normalizedWorkTime)) {
            price += surcharge;
        }

        if (!isPickup && isOffHours(finishHours, 0, normalizedWorkTime)) {
            price += surcharge;
        }
    }

    return price;
};

export const shouldAddLocationToTotal = (service) => {
    return parseInt(service?.add_to_total, 10) === 1;
};

export const isFixedLocationPrice = (service) => {
    return shouldAddLocationToTotal(service) && parseInt(service?.add_from_prefix, 10) !== 1;
};

export const getLocationServiceTotalPrice = (service, options = {}) => {
    if (!shouldAddLocationToTotal(service)) {
        return 0;
    }

    return getLocationServicePrice(service, options);
};

export const getFixedLocationServiceTotalPrice = (service, options = {}) => {
    if (!isFixedLocationPrice(service)) {
        return 0;
    }

    return getLocationServicePrice(service, options);
};

export const sortLocationServices = (services, isMobile = false) => {
    const sortKey = isMobile ? 'sort_mobile' : 'sort_desktop';

    return [...(services || [])].sort((a, b) => {
        const aSort = parseInt(a?.[sortKey], 10) || 0;
        const bSort = parseInt(b?.[sortKey], 10) || 0;
        return aSort - bSort;
    });
};

export const formatLocationPriceLabel = (service, price, lang = 'ru') => {
    if (!price) {
        return '';
    }

    const prefix = parseInt(service?.add_from_prefix, 10) === 1
        ? (lang === 'en' ? 'from ' : 'от ')
        : '+';

    return ` (${prefix}${formatPrice(price)})`;
};
